// Variantes responsivas para imagens do backoffice (/api/uploads/*.webp).
// O servidor gera uma variante -800.webp no upload; imagens antigas foram migradas.

export const uploadSrcSet = (url) => {
  if (!url || !url.includes("/api/uploads/") || !url.endsWith(".webp") || url.endsWith("-800.webp")) return undefined;
  return `${url.replace(/\.webp$/, "-800.webp")} 800w, ${url} 1920w`;
};

// Se a variante não existir (404), remove o srcset e volta ao original.
export const srcSetFallback = (e) => {
  if (e.currentTarget.getAttribute("srcset")) {
    e.currentTarget.removeAttribute("srcset");
    e.currentTarget.removeAttribute("sizes");
  }
};
